<template>
  <transition name="fade">
    <div v-if="show" class="popup_wrapper" @click.self="wrapperClick()">

      <div class="popup" :style="{ top: y + 'px', left: x + 'px'}">
        <slot></slot>
      </div>

    </div>
  </transition>
</template>

<script>
export default {
  name: 'popup',
  data() {
    return {
      x: 0,
      y: 0,
      show: false,
    };
  },
  methods: {
    wrapperClick() {
      this.show = false;
    },
    openMenu() {
      this.show = true;
    },
    closeMenu() {
      this.show = false;
    },
    setPosition(e) {
      let targetRect = e.target.getBoundingClientRect();
      let clientWidth = window.innerWidth;
      this.x = targetRect.x;
      this.y = targetRect.y + 24;
      if (clientWidth < 767) {
        // eslint-disable-next-line no-mixed-operators
        this.x = targetRect.x > clientWidth / 2 ? clientWidth / 2 - 50 : targetRect.x;
        this.y = window.innerHeight - 250;
      }
    },
  },
};

</script>

<style lang="sass">

.popup
  position: absolute
  z-index: 2
  // background: #fff
  // box-shadow: 0px 0px 4px #333
  border-radius: 5px
  overflow: hidden
  background-color: #181823
  // -webkit-mask-image: -webkit-radial-gradient(white, black)

  &_wrapper
    +full-size(0, fixed)
    z-index: 999
    background: rgba(7, 22, 71, 0.06)
    transition: .2s ease
    // -webkit-mask-image: -webkit-radial-gradient(white, black)

  &_list
    // background-color: #181823
    // box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)
    // background-color: pink
    &-item
      // line-height: 4.2rem
      font-size: 1.1rem
      font-weight: 400
      padding: 0 1.3rem
      // transition: .2s ease
      height: 4.2rem
      display: flex
      align-items: center
      white-space: nowrap
      &:hover
        // background-color: #27283C

</style>
